import React from 'react';
import { Row, Col, Spin, Image } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import { LoadingOutlined } from '@ant-design/icons';
import { gaEvent } from '../../utils';
import { queries } from '../../graphql/graphql';
import _s from './index.less';

const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const MapView = ({ mapId, plan }) => {
  const { data = {}, loading } = useQuery(queries.MAP_RESULT, {
    variables: { id: mapId }
  });
  const { mapResult } = data;

  if (!loading && !mapResult) {
    const onClick = () => {
      try {
        localStorage.setItem('lastViewed', plan.id);
      } catch (error) {
        console.error(error);
      }
      gaEvent('planView', 'click:tryItOnMyLot', 'tryItOnMyLot');
    };
    return (
      <Row style={{ paddingLeft: 16, paddingRight: 16 }}>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <span className={_s.block_title}>Map</span>
            </Col>
          </Row>
          <Row>
            <Col span={24} lg={16}>
              <a
                className={_s.view3d_container}
                href={'/'}
                onClick={onClick}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={'/public/images/map_placeholder.png'}
                  alt="Configure"
                  className={_s.imageView3d}
                  style={{ filter: 'blur(10px)' }}
                />
                <div className={_s.view3d} style={{ width: '450px' }}>
                  Overlay this floor plan over your property
                </div>
              </a>
            </Col>
            <Col span={24} lg={8} className={_s.mapInformation}>
              <Col span={24}>
                <Image
                  src={`https://3d.homewip.com/svg/${plan.planId}/`}
                  className={_s.mapInformationSVG}
                />
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  if (loading)
    return (
      <Row justify="center">
        <Col>
          <Spin size="large" indicator={antIcon} />
        </Col>
      </Row>
    );

  const { snapshot, map } = mapResult;

  return (
    <Row style={{ paddingLeft: 16, paddingRight: 16 }}>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <span className={_s.block_title}>Map</span>
          </Col>
        </Row>
        <Row>
          <Col span={24} lg={16} className={_s.mapSnapshot}>
            <Image src={snapshot} alt="Configure" className={_s.mapSnapshot} />
          </Col>
          <Col span={24} lg={8} className={_s.mapInformation}>
            <Col span={24}>
              <Image
                src={`https://3d.homewip.com/svg/${plan.planId}/`}
                className={_s.mapInformationSVG}
              />
            </Col>
            <Col span={24} className={_s.mapInformation}>
              <span className={_s.titlePlan}>Address: {map.address || 'Address is empty'}</span>
            </Col>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default MapView;
